<template>
  <div>
    <top-bar heading="User Activity"></top-bar>
    <div class="container-fluid mt-3">
      <b-card>
        <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="users.data"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :pagination-options="paginationOptions"
                :isLoading="loading"
                :total-rows="totalRecords"
        >
        </vue-good-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import forEach from 'lodash-es/forEach';

export default {
  name: 'UserActivity',
  data () {
    return {
      users: {
        meta: {
          current_page: 1,
          per_page: 10
        },
        data: []
      },
      loading: true,
      columns: [
        {
          label: 'First Name',
          field: 'user.name_first',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Last Name',
          field: 'user.name_last',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Activity',
          field: 'activity',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'When',
          field: 'created_at',
          filter: {
            placeholder: ' Search..'
          }
        },
        {
          label: 'User Agent',
          field: 'platform'
        },
        {
          label: 'IP',
          field: 'geoip'
        },
        {
          label: 'Object',
          field: 'thing_object'
        }
      ],
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      }
    };
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange (params) {
      this.updateParams({page: params.currentPage});
      this.getUsers();
    },

    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage});
      this.getUsers();
    },

    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }
      });
      this.getUsers();
    },

    onColumnFilter (params) {
      this.updateParams(params);
      this.getUsers();
    },

    getUsers () {

      let params = {
        page: this.serverParams.page,
        limit: this.serverParams.perPage,
        sort: this.serverParams.sort.field,
        sortBy: this.serverParams.sort.type
        // search: this.search
      };

      forEach(this.serverParams.columnFilters, (value, index) => {
        params['filter[' + index + ']'] = value;
      });

      this.loading = true;
      this.axios.get('users/activity', {params}).then((rsp) => {

        rsp.data.data = rsp.data.data.map(user => {
          user.created_at = this.$moment(user.created_at).format('MMM Do YYYY, h:mm a');

          return user;
        });

        this.users = rsp.data;

        this.loading = false;
      });
    }
  },
  computed: {
    paginationOptions () {
      return {
        enabled: true,
        mode: 'records',
        perPage: this.users.meta.per_page,
        position: 'bottom',
        dropdownAllowAll: false,
        setCurrentPage: this.users.meta.current_page || 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        allLabel: 'All'
      };
    },
    totalRecords () {
      return this.users.meta.total || 0;
    }
  },
  mounted () {
    this.getUsers();
  },
  metaInfo: {
    title: 'User Activity'
  }
};
</script>
